var _g, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 30",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "delete, trash, trash can, uninstall, garbage, can, rubbish, button, ui, bin,") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.62988,20.18a2.75349,2.75349,0,0,0,2.74024,2.57h9.25976a2.75349,2.75349,0,0,0,2.74024-2.57l.77-11.43H3.85986ZM13,13a1,1,0,0,1,2,0v4a1,1,0,0,1-2,0ZM9,13a1,1,0,0,1,2,0v4a1,1,0,0,1-2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75,6A1.75213,1.75213,0,0,0,20,4.25H16.84253a1.7443,1.7443,0,0,0-.07007-.80322l-.333-1.00049A1.74753,1.74753,0,0,0,14.7793,1.25H9.2207A1.74734,1.74734,0,0,0,7.56055,2.44678l-.333.99951A1.74653,1.74653,0,0,0,7.15747,4.25H4a1.75,1.75,0,0,0,0,3.5H20A1.75213,1.75213,0,0,0,21.75,6ZM8.68457,4.146a.24546.24546,0,0,1-.03418-.22559l.333-.99951A.25.25,0,0,1,9.2207,2.75h5.5586a.25023.25023,0,0,1,.2373.17041l.333,1.00049a.25.25,0,0,1-.23682.3291H8.88721A.24368.24368,0,0,1,8.68457,4.146Z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 39,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "Created by Nursila")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 44,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "from the Noun Project")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.86283ae62c05ff363057a4e2198b1d6e.svg";
export { ForwardRef as ReactComponent };